// Serial-number column for the Payment Report tables. Position in the current
// view, continuous across pages: (page - 1) * pageSize + index + 1. Counts voided
// rows (they are rows in the view). Purely visual — never stored.

export function snValue(page: number, pageSize: number, index: number): number {
  return (page - 1) * pageSize + index + 1
}

/** Body cell rendering the row's serial number. */
export function SnCell({ page, pageSize, index }: { page: number; pageSize: number; index: number }) {
  return (
    <td className="px-4 py-3 text-right tabular-nums text-gray-400">
      {snValue(page, pageSize, index)}
    </td>
  )
}

/** Matching header cell. */
export function SnHeader() {
  return <th className="px-4 py-3 text-right">SN</th>
}
